import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { OeAppPersonService } from '../../shared/oe-app-person.service';
import { OeAppService } from '../../shared/oe-app.service';

export enum PrivateClassEventType {
  GO_TO_HOME = 'GoToHome',
}

@Component({
  selector: 'lp2-referrals-page',
  styleUrls: ['./referrals-page.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <section *ngIf="referralsPageFrameUrl; else loading" class="referrals-page">
      <iframe class="ReferralsPageIFrame" [src]="referralsPageFrameUrl | safeUrl"></iframe>
    </section>

    <ng-template #loading>
      <div class="loading-container py-4">
        <div class="loader"></div>
      </div>
    </ng-template>
  `,
})
export class ReferralsPageComponent implements OnInit {
  public referralsPageFrameUrl: string;

  constructor(
    private oeApp: OeAppService,
    private oeAppPersonService: OeAppPersonService,
  ) {}

  ngOnInit() {
    this.referralsPageFrameUrl = this.getReferralUrl();
  }

  private getReferralUrl() {
    const versant = this.oeApp.supportedLanguages().find((l) => l.code === this.oeAppPersonService.preferredLang);
    return (
      `${this.oeApp.webReferralPageHost}` +
      `/extole.html?partner_user_id=${this.oeAppPersonService.contactId}` +
      `&email=${this.oeAppPersonService.getPersonData().email}` +
      `&firstName=${this.oeAppPersonService.getPersonData().firstName}` +
      `&lastName=${this.oeAppPersonService.getPersonData().lastName}` +
      `&locale=${versant.versantLanguageCode}` +
      `&source=""`
    );
  }
}



// WEBPACK FOOTER //
// ./ts/app/referrals/referrals-page/referrals-page.component.ts